import { Component, OnInit, Input, EventEmitter, Output, OnChanges, SimpleChange } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { User } from '../../users/models/user.model';

@Component({
    selector: 're-enroll-mfa',
    templateUrl: './enroll-mfa.component.html',
    styleUrls: ['./enroll-mfa.component.scss'],
    standalone: false
})
export class EnrollMfaComponent implements OnInit, OnChanges {

  @Input() user: User = new User();
  @Input() smsMFAPending: boolean;
  @Input() smsMFAAction: string;
  @Output() clickevent = new EventEmitter();
  @Output() updateEvent = new EventEmitter();
  @Output() authorizeEvent = new EventEmitter();

  private phoneNumPattern = /^[0-9]{10}$/;
  phoneFactorForm: UntypedFormGroup;

  constructor(
    public modal: NgbActiveModal,
    private fb: UntypedFormBuilder
  ) {
    this.createPhoneFactorForm();
  }

  ngOnInit() {
  }

  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    // Track change?
  }

  submit() {
    if (this.smsMFAAction === 'update') {
      this.smsMFAAction = 'send update';
    }
    this.clickevent.emit(this.phoneFactorForm);
  }

  update() {
    this.updateEvent.emit('update');
  }

  authorize() {
    this.authorizeEvent.emit('authorize');
  }

  createPhoneFactorForm() {
    this.phoneFactorForm = this.fb.group({
      phoneNumber: ['', [Validators.required, Validators.pattern(this.phoneNumPattern)]],
      smsPhoneCode: ['', Validators.required],
    });
  }

}
